import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@chakra-ui/react";
import parse from 'html-react-parser';
// Main components
import MainLayout from "../../../components/main/layout/layout";
// Maintenance components
import MaintenanceDetail from "../../../components/maintenance/detail/detail";
// Components
import FilesList from "../../../components/filesList/filesList";
// Actions
import * as mainActions from "../../../redux/actions/main";
import * as newsActions from "../../../redux/actions/news";
// Utils
import { 
  formatDateToMadridTime, 
} from "../../../utils/formatters";
// Styles
import "./detail.css";

const NewsDetail = () => {
  const dispatch = useDispatch();
  // States
  const [isLoading, setIsLoading] = useState(false);
  const [detail, setDetail] = useState(null);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage); 
  const user = useSelector(state => state.authReducer.user);

  // Set constants
  const page = "news";
  const primaryName = !!detail && !!detail.title ? detail.title : ``;
  const itemNameSingular = "Notícia";

  // Get id from url
  const { id: paramId } = useParams();
  const id = parseInt(paramId);
  // console.log('id', id);
  
  useEffect(() => {
    if (!!currentPage) return;
    // Set active page
    dispatch(mainActions.setCurrentPage(page));
    // Set initial breadscrum
    const pathKey = 'detail';
    const path = `${page}/${pathKey}/${id}`;
    dispatch(mainActions.setBreadscrum(page, [{ path, pathKey, primaryValue: id, primaryName, itemNameSingular, }])); 
  }, []);

  const renderDetail = () => {
    // console.log('renderDetail > detail', detail);
    if (!detail) return null;
    return (
      <div className="news-detail-cards-wrapper">
        {renderMainCard()}
        <div className="news-detail-secondcard">
          {renderDynamicContent()}
        </div>
      </div>
    );
  };

  const renderMainCard = () => {
    const url_web = !!detail.url_web ? parse(`<a href="${detail.url_web}" target="_blank">${detail.url_web}</a>`) : "";
    
    return (
      <div className="maintenance-detail-card news-detail-card">
        <div className="title maintenance-detail-title">
          {detail.title}
        </div>
        {renderField("Id", detail.id)}
        {renderField("Habilitat", detail.enabled ? "SI" : "NO")}   
        {renderFilesList()}
        {renderField("Texte imatge", detail.text_image_1)}
        {renderField("Títol", detail.title)}
        {renderField("Data", formatDateToMadridTime(detail.date, true))} 
        {renderField("Prioritat", detail.priority)}
        {renderField("Categoria", detail.category)}
        {renderField("Autor", detail.author)}
        {renderField("Sub-títol", detail.subtitle)}
        {renderField("Url Web", url_web)}
        <Box h={"20px"}></Box>            
        {renderField("Data de creació", formatDateToMadridTime(detail.creation_date))}
        {renderField("Usuari de creació", detail.creation_user)}
        {renderField("Data última modificació", formatDateToMadridTime(detail.last_modification_date))}
        {renderField("Usuari última modificació", detail.last_modification_user)}
      </div>
    );
  };

  const renderFilesList = () => {
    const url_image_1 = !!detail.url_image_1 ? parse(`<a href="${detail.url_image_1}" target="_blank">${detail.url_image_1}</a>`) : "";
    return (
      <div className="news-detail-fileslist-wrapper">
        <Box className="maintenance-detail-label">
          Imatge principal
        </Box>
        {!!url_image_1 && (
          <Box mt="3px" className="maintenance-detail-field">
            {url_image_1}
          </Box>       
        )}     
        <FilesList
          type={"news"}
          id={id}
          id2={"1"}
          setIsLoading={setIsLoading}
          label={""}
        />     
      </div>
    );
  };

  const renderDynamicContent = () => {

    if (!detail.json_content || detail.json_content.length == 0) {
      return null;
    }

    // Loop each content item
    const indents = [];
    for (let i = 0; i < detail.json_content.length; i++) {
      const item = detail.json_content[i];
      
      if (item.type == "text") {
        indents.push(
          <Box mt="10px" textAlign="justify">
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {parse(item.description)}
            </div>
          </Box>
        );
      } else if (item.type == "audio" || item.type === "image") {
        indents.push( 
          <Box mt="10px">
            <FilesList
              type={"news"}
              id={id}
              id2={item.id2}
              setIsLoading={setIsLoading}
              label={""}
            />    
          </Box>
        );
      }
    }

    return (
      <div className="news-detail-content-wrapper">
        <Box className="maintenance-detail-label">
          Contingut
        </Box>
        {indents}
      </div>
    );
  };

  const renderField = (label, value) => {
    return (
      <div className="maintenance-detail-field-parent">
        <Box className="maintenance-detail-label" w={"220px"}>
          {label}
        </Box>    
        <Box className="maintenance-detail-field">
          {value}
        </Box>         
      </div>
    );
  };

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="news-detail-content">
        <MaintenanceDetail 
          primaryValue={id}
          primaryName={primaryName}
          menuConfig={{
            buttonEdit: { visible: !!user && user.grants.news },
            buttonDelete: { visible: !!user && user.grants.news },
          }}
          itemNameSingular={itemNameSingular}
          itemIsMale={false}
          actions={newsActions} 
          setIsLoading={setIsLoading}
          renderDetail={renderDetail}
          setDetail={setDetail}
          page={"news"}
        />
      </div>
    </MainLayout>
  );
};

export default NewsDetail;
